import axios from 'axios'

// const API_URL = '/api/users/'
const API_URL = 'http://localhost:3001/api/users/'

// Register user
const register = async (userData) => {
  const response = await axios.post(API_URL + 'register', userData)
  console.log(response.data)
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Login user
const login = async (userData) => {
  const response = await axios.post(API_URL + 'login', userData)
  console.log(response.data)
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Update user
const update = async (userData) => {
  // const user = JSON.parse(localStorage.getItem('user'));
  const response = await axios.put(API_URL + 'update', userData)
  window.alert(response.data)
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Get current user
const getMe = async (userData) => {
  const response = await axios.get(API_URL + 'me', userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Logout user
const logout = () => {
  localStorage.removeItem('user')
}

const authService = {
  register,
  logout,
  login,
  update,
  getMe
}

export default authService
